var map = {
	"./Alefantinos.jpg": 536,
	"./Anipsitaki.jpg": 144,
	"./Holmes.jpg": 46,
	"./Kouratoras.jpg": 627,
	"./Somaki.jpg": 212,
	"./Vergianos.jpg": 282,
	"./Xanthioti.png": 810,
	"./kampitaki.jpeg": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 751;